import React from 'react';
import history from '../../history';
import config from 'config';
import Table from 'components/table';
import {showRating} from './rating-detail-list';

export const RatingList = ({ rating }) => (
  <Table black hover>
    <thead>
      <tr>
        <th>Номер оцінки</th>
        <th>Лікарня</th>
        <th>Лікар</th>
        <th>Коментар</th>
        <th>Дата створення</th>
        <th>Оцінка</th>
      </tr>
    </thead>
    <tbody>
      {rating.get('results').map((item, i) => (
        <tr key={item.get('id')} onClick={() => history.push(`/cabinet/rating/detail/${item.get('id')}`)}>
          <td><span>Номер оцінки:</span>{item.get('id')}</td>
          <td><span>Лікарня:</span>{item.get('staff_data').get('institution_data').get('full_title')}</td>
          <td><span>Лікар:</span>{item.get('staff_data').get('user_data').get('last_name')} {item.get('staff_data').get('user_data').get('first_name')} {item.get('staff_data').get('user_data').get('middle_name')}</td>
          <td><span>Коментар:</span>{item.get('comment') || "коментар відсутній"}</td>
          <td><span>Дата створення: </span>{new Date(item.get('date_created')).toLocaleString('uk-UA', config.options)}</td>
          <td><span>Оцінка:</span>{showRating(item.get('rating'))}</td>
        </tr>
      ))}
    </tbody>
  </Table>
)



// WEBPACK FOOTER //
// ./src/cabinet/rating/rating-list.js